import {
  Box,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState, useCallback } from "react";
import NewIncomeExpenseModal from "@/modules/finance/components/NewIncomeExpenseModal";
import axiosInstance from "@/setup/axios/axiosInstance";

interface OrderPaymentCollectionProps {
  orderId?: string;
  contextCompanyId?: string;
  disabled?: boolean;
  onPaymentCollected?: (transaction: any) => void;
  walletId?: string;
}

export default function OrderPaymentCollection({
  orderId,
  contextCompanyId,
  disabled = false,
  onPaymentCollected,
  walletId,
}: OrderPaymentCollectionProps) {
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const handleCreateTransaction = useCallback(async (incomeExpenseData: any) => {
    try {
      const { selectedFiles, ...incomeData } = incomeExpenseData;

      const transactionPayload = {
        posting_date: incomeData.posting_date,
        document_date: incomeData.document_date,
        transaction_type: incomeData.transaction_type,
        actual_amount: incomeData.actual_amount,
        total_amount: incomeData.total_amount,
        wallet: incomeData.wallet,
        note: incomeData.note,
        order: orderId || incomeData.order || '',
        customer: incomeData.customer,
        employee: incomeData.employee,
        supplier: incomeData.supplier,
        company_id: incomeData.company_id || contextCompanyId || undefined,
        company: incomeData.company || incomeData.company_id || contextCompanyId || undefined,
        status: incomeData.status,
      };

      let response;
      if (orderId) {
        response = await axiosInstance.post(`/orders/${orderId}/transactions/`, transactionPayload);
      } else {
        response = await axiosInstance.post('/finance/transactions/', transactionPayload);
      }

      const createdTransaction = response.data.transaction || response.data;

      if (selectedFiles && selectedFiles.length > 0) {
        const { uploadTransactionDocument } = await import('@/modules/documents/redux/DocumentCRUD');
        for (const file of selectedFiles) {
          try {
            await uploadTransactionDocument(createdTransaction.id, file);
          } catch (fileError) {
            console.error(`Failed to upload file ${(file as File).name}:`, fileError);
          }
        }
      }

      if (onPaymentCollected) {
        onPaymentCollected(createdTransaction);
      }

      setShowPaymentForm(false);
    } catch (err: any) {
      throw err;
    }
  }, [orderId, contextCompanyId, onPaymentCollected]);

  return (
    <Box>
      <NewIncomeExpenseModal
        open={showPaymentForm}
        onClose={() => setShowPaymentForm(false)}
        onSubmit={handleCreateTransaction}
        orderId={orderId}
        contextCompanyId={contextCompanyId}
        transactionCategory="income"
        defaultWalletId={walletId}
      />

      {!disabled && (
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          size="small"
          onClick={() => setShowPaymentForm(true)}
          sx={{
            color: "#10b981",
            borderColor: "#10b981",
            "&:hover": {
              borderColor: "#059669",
              backgroundColor: "#f0fdf4",
            },
          }}
        >
          Thu tiền hàng
        </Button>
      )}
    </Box>
  );
}
